









import { Vue, Component, Prop } from 'vue-property-decorator';

import DetailedSlotGeneric from './DetailedSlotGeneric.vue';

import { ReservedSlot } from '../types';

@Component({
    components: {
        DetailedSlotGeneric,
    },
})
export default class DetailedSlotReserved extends Vue {
    @Prop() event!: ReservedSlot

    get title() {
        if (this.event.clinic) {
            return this.event.clinic.title;
        }

        return this.event.consultation.title
    }
}
